!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.root = document.documentElement, this._ticking = !1, this.updateHeight = this.updateHeight.bind(this), 
      this.handleClose = this.handleClose.bind(this), this.handleScrollOrResize = this.handleScrollOrResize.bind(this);
    }
    connectedCallback() {
      this.observer = new IntersectionObserver(e => {
        e.forEach(e => {
          e.isIntersecting || this.hasAttribute("data-sticky") ? this.updateHeight() : (this.root.style.setProperty("--announcement-height", "0px"), 
          this.updateHeaderHeight());
        });
      }, {
        threshold: [ 0, 1 ]
      }), this.observer.observe(this), window.addEventListener("scroll", this.handleScrollOrResize, {
        passive: !0
      }), window.addEventListener("resize", this.handleScrollOrResize, {
        passive: !0
      });
      const e = this.querySelector('button[aria-label="Close"]');
      e && e.addEventListener("click", this.handleClose);
      const t = this.querySelector("fade-slider");
      t && window.innerWidth >= 1024 && sessionStorage.getItem("announcement-closed") && (t.style.display = "none", 
      this.root.classList.add("announcement-dismissed")), requestAnimationFrame(() => this.updateHeight());
    }
    disconnectedCallback() {
      this.observer && this.observer.disconnect(), window.removeEventListener("scroll", this.handleScrollOrResize), 
      window.removeEventListener("resize", this.handleScrollOrResize);
      const e = this.querySelector('button[aria-label="Close"]');
      e && e.removeEventListener("click", this.handleClose);
    }
    handleScrollOrResize() {
      this._ticking || (this._ticking = !0, requestAnimationFrame(() => {
        this.updateHeight(), this._ticking = !1;
      }));
    }
    handleClose() {
      const e = this.querySelector("fade-slider");
      e && (e.style.display = "none"), sessionStorage.setItem("announcement-closed", "true"), 
      this.root.classList.add("announcement-dismissed"), this.updateHeight();
    }
    updateHeight() {
      const e = this.getBoundingClientRect(), t = document.querySelector("[data-header]") || document.querySelector("header"), i = t?.querySelector("site-header"), s = Math.round(i?.getBoundingClientRect().height) || 0;
      let n = 0;
      e.height > 0 && (n = "true" === this.getAttribute("data-sticky") ? e.height : e.bottom > 0 ? Math.max(0, Math.min(e.height, e.bottom)) : 0), 
      this.updateHeaderHeight(e, s, n);
    }
    updateHeaderHeight(e = this.getBoundingClientRect(), t, i) {
      if (void 0 === t) {
        const e = document.querySelector("[data-header]") || document.querySelector("header"), i = e?.querySelector("site-header");
        t = Math.round(i?.getBoundingClientRect().height) || 0;
      }
      this.initialHeaderHeight && this._lastWindowWidth === window.innerWidth || (this.initialHeaderHeight = t, 
      this._lastWindowWidth = window.innerWidth), void 0 === i && (i = parseFloat(this.root.style.getPropertyValue("--announcement-height")) || 0);
      const s = i > 0 ? t + i - 2 : t, n = this.root.classList.contains("announcement-dismissed"), h = e.height > 0 && !n ? e.height : 0, o = h > 0 ? this.initialHeaderHeight + h - 2 : this.initialHeaderHeight;
      this.root.style.setProperty("--announcement-height", `${i}px`), this.root.style.setProperty("--header-height", `${s}px`), 
      this.root.style.setProperty("--base-header-height", `${this.initialHeaderHeight}px`), 
      this.root.style.setProperty("--base-total-header-height", `${o}px`), this.root.style.setProperty("--base-announcement-height", `${h}px`);
    }
  }
  customElements.define("announcement-bar", e);
}();